<template>
  <div class="hero-image-paris  position-relative">
    <img :src="image__sm" class="d-inline d-md-none img--center" :alt="alt" />
    <img
      :src="image"
      class="d-none d-md-inline"
      :class="right ? 'img--right' : 'img--center'"
      :alt="alt"
    />

    <div class="container h-100 position-relative hero-home-container">
      <b-row class="h-100 position-relative">
        <b-col
          cols="12"
          v-if="isHome"
          class="is-home d-flex align-items-start align-items-lg-end justify-content-start justify-content-md-start"
        >
          <div>
            <h1>
              Embrace Your Sparkle
            </h1>
            <p class="fw-bold">
              Paris Hilton Is Empowering the ADHD Community and Highlighting the Importance of Individualized Treatment Plans
            </p>
            <small
              v-if="!isHome"
              class="portrayal portrayal-mob fw-bold text-white"
              >Actor portrayal. Individual results may vary.</small
            >
          </div>
        </b-col>
        <b-col
          cols="12"
          md="7"
          v-else
          class="d-flex align-items-end justify-content-start justify-content-md-start"
        >
          <div>
            <h1 class="font-fields" v-html="title"></h1>
            <p
              v-if="subtitle"
              class="fw-bold hero__subtitle"
              v-html="subtitle"
            ></p>
            <small class="portrayal portrayal-mob fw-bold text-white"
              >Actor portrayal. Individual results may vary.</small
            >
          </div>
        </b-col>
      </b-row>

      <small
        v-if="!isHome"
        class="portrayal portrayal-desk fw-bold text-white d-flex flex-column"
      >
        <span>
          Actor portrayal.
        </span>
        <span>Individual results may vary.</span>
      </small>

      <div class="home-hero-bottom-gradient"></div>
    </div>
    <div v-if="isHome" class="purple-box position-absolute text-white fw-bold">
      <p class="m-0">
        Paris Hilton is a JORNAY PM<sup>®</sup> patient and compensated brand
        ambassador.
      </p>
      <p class="m-0 d-block">
        Individual results may vary.
        <span class="d-block d-lg-inline">Intended for U.S. audiences.</span>
      </p>
    </div>
    <div class="d-md-none d-block">
      <div
        v-if="isHome"
        class="gradiant-purple-box position-absolute text-white fw-bold d-flex  align-items-end mb-0 justify-content-center"
      >
        <p class="fw-bold mobile-p"></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    image: String,
    image__sm: String,
    timeStamp1: String,
    timeStamp2: String,
    title: String,
    titleImage: String,
    subtitle: String,
    alt: String,
    right: Boolean,
    margin: Boolean,
    noSubtitleMobile: Boolean,
    disclaimer: String,
    isHome: Boolean,
    pre: String,
    post: String,
    copy: String,
  },
  data() {
    return {
      isShown: false,
    };
  },
  mounted() {
    setInterval(() => {
      this.isShown = !this.isShown;
    }, 1000);
  },
};
</script>

<style lang="scss" scoped>
// .hero-image {
//   position: relative;
//   width: 100%;
//   overflow: hidden;
//   box-shadow: unset;

//   height: 414px;
//   background: linear-gradient(to right, #2DA7DF 0%, #F8C222 100%);

//   @media (min-width: 768px) {
//     height: 592px;
//   }

//   >img {
//     margin-top: 6px;
//     width: 100%;
//     height: 100%;
//     position: absolute;
//     top: 0;
//     right: 0;
//     object-fit: cover;
//   }

//   .img--right {
//     object-position: top right;
//   }

//   .img--center {
//     object-position: top center;
//   }

//   .is-home {
//     padding-top: 0;

//     span {
//       line-height: 29px;
//       font-size: 25px;
//       font-weight: bold;
//     }

//     p {
//       margin-top: 33px;
//       color: #fff;
//       font-size: 16px;
//       max-width: 430px;
//     }

//     .svg-container {
//       padding: 8px 0 17px;
//     }

//     @media (max-width: 992px) {
//       padding-bottom: 31px;

//       p {
//         margin: 10px 0 0;
//         line-height: 18px;
//       }

//       span {
//         font-size: 16px;
//         line-height: 18px;
//       }

//       .pre-copy {
//         line-height: 12px;
//         font-size: 15px;
//       }

//       .svg-container {
//         padding: 0;
//         margin: 8px 0 10px;
//         max-width: 215px;
//         max-height: 130px;

//         img {
//           width: 100%;
//         }
//       }
//     }
//   }

//   .hero-contents {
//     // h1 {
//     //   font-size: 36px;
//     //   margin-bottom: 0;
//     //   color: #2DA7DF;

//     //   @media (min-width: 768px) {
//     //     font-size: 95px;
//     //     line-height: 84px;
//     //   }
//     // }

//     // span.subtitle {
//     //   font-size: 20px;
//     //   font-weight: 600;
//     //   line-height: 28px;
//     //   margin-bottom: 0;
//     // }
//   }
// }

// .hero__subtitle {
//   // font-size: 18px;
//   // font-weight: 600;
//   // line-height: 1.6;
//   // margin-top: 10px;
//   color: #fff;

//   @media (min-width: 768px) {
//     // max-width: 430px;
//     // letter-spacing: .3px;
//     // font-size: 25px;
//     // line-height: 29px;
//     // margin-top: 20px;
//     // font-weight: bold;

//   }
// }
</style>
